// AUTO-GERADO por scripts/generate-version.ts — não editar à mão.
// Tipados como string (não literal) pra evitar type narrowing em comparações.
export const APP_VERSION: string = "1.73.0";
export const APP_COMMIT_SHA: string = "d48310c";
export const APP_BUILD_TIME: number = 1793674465638;
